import { OPEN_HAMBURGER_NAV, CLOSE_HAMBURGER_NAV } from '../../../../ActionsConst';

export const openHamburgerNav = () => ({
  type: OPEN_HAMBURGER_NAV,
});

export const closeHamburgerNav = () => ({
  type: CLOSE_HAMBURGER_NAV,
});
